import { render } from "./Propagandas.vue?vue&type=template&id=a9b6180c&scoped=true"
import script from "./Propagandas.vue?vue&type=script&lang=js"
export * from "./Propagandas.vue?vue&type=script&lang=js"

import "./Propagandas.vue?vue&type=style&index=0&id=a9b6180c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b6180c"]])

export default __exports__